<template>
  <div>
    <v-card>
      <v-card-text>
        <v-tabs v-model="tab" show-arrows>
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#Edit">
            <h6>ویرایش</h6>
          </v-tab>
          <v-tab href="#Info">
            <h6>جزییات</h6>
          </v-tab>
          <v-tab href="#Message">
            <h6>پیام ها</h6>
          </v-tab>
          <v-tab href="#Event">
            <h6>رویداد ها</h6>
          </v-tab>
        </v-tabs>

        <v-divider></v-divider>
        <v-tabs-items v-model="tab" v-if="selectedSupplierProduct">
          <v-tab-item :value="'Edit'">
            <supplier-product-form
              :categoryType="supplierProductType"
              :categoryTypeDisplayName="categoryTypeDisplayName"
              :forEdit="true"
              :editActionName="editActionName"
              :properties="selectedSupplierProduct.productProperties"
              :productProperties="selectedSupplierProduct.properties"
            >
              <!-- اینجا مفهوم دو مورد ویژگیها برعکس هست -->
            </supplier-product-form>
          </v-tab-item>
          <v-tab-item :value="'Info'">
            <supplier-product-detail
              :categoryType="supplierProductType"
              :selectedSupplierProduct="selectedSupplierProduct"
              :id="id"
            ></supplier-product-detail>
          </v-tab-item>
          <v-tab-item :value="'Message'">
            <ThreadsList
              @getConversationId="getConversationId"
              @closeThreadList="null"
              topic="SupplierProduct"
              type="AdminMerchant"
              :key="key"
              :objectId="id"
              :conversationId="
                conversationList && conversationList.length
                  ? conversationList[0].conversationId
                  : null
              "
              :recipientMerchantId="merchantId ? merchantId : null"
              :recipientUserId="null"
              :createdByMerchantId="merchantId ? merchantId : null"
              :isUserBase="false"
            >
            </ThreadsList>
            <!-- <ConversationList></ConversationList> -->
          </v-tab-item>

          <v-tab-item :value="'Event'">
            <supplier-product-events
              :eventsList="eventsList"
              @getSupplierProductEvents="getSupplierProductEvents"
            ></supplier-product-events>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ThreadsList from '@/components/core/conversation/components/ThreadsList.vue';
import Helper from '@/core/helpers';
const enumsRepository = () => RepoFactory.get('enums');
const conversationRepository = () => RepoFactory.get('conversation');
import { RepoFactory } from '@/baseRepository/Factory';
const supplierProductRepository = RepoFactory.get('supplierProduct');
import SupplierProductForm from '../components/SupplierProductNewForm.vue';
import SupplierProductDetail from '../components/SupplierProductDetail.vue';
import ConversationList from '@/components/core/conversation/components/ConversationList.vue';
import SupplierProductEvents from '../components/SupplierProductEvents.vue';
export default {
  components: {
    SupplierProductForm,
    SupplierProductDetail,
    ConversationList,
    ThreadsList,
    SupplierProductEvents,
  },
  data() {
    return {
      conversationList: [],
      categoryTypeItemsList: [],
      categoryTypeDisplayName: null,
      selectedSupplierProduct: null,
      eventsList: null,
      itemsPerPageEvents: null,
      key: 0,
      editActionName: 'unknown', // We should calulate it =>  "EditProdNoBase" or "EditProdByBase"
    };
  },

  computed: {
    productBaseUrl() {
      return this.$store.getters.productBaseUrl;
    },
    contentBaseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
    id() {
      return this.$route.params.id;
    },
    tab: {
      set(tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } });
      },
      get() {
        return this.$route.query.tab;
      },
    },
    supplierProductType() {
      return this.$route.params.supplierProductType;
    },
  },

  created() {
    this.getCategoryTypeItemsList();
    this.getSupplierProductById();
    this.getConversaion();
  },
  watch: {
    tab(after, before) {
      if (after == 'Event') {
        this.getSupplierProductEvents(1, this.itemsPerPageEvents);
      }
    },
  },
  methods: {
    getConversationId(val) {
      this.conversationList[0].conversationId = val;
      this.key = this.key + 1;
    },
    getSupplierProductEvents(pageNumber, itemsPerPage) {
      const loader = this.$loading.show();
      this.itemsPerPageEvents = itemsPerPage;
      supplierProductRepository
        .getSupplierProductEvents(
          this.id,
          this.productBaseUrl,
          {},
          {
            PageNumber: pageNumber,
            ItemsPerPage: itemsPerPage,
          }
        )
        .then((res) => {
          this.eventsList = res.data;
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
    getSupplierProductById() {
      const loader = this.$loading.show();
      supplierProductRepository
        .getSupplierProductById(this.id, this.productBaseUrl, {})
        .then((res) => {
         //alert("res.data.productCreatedByThisMerchant="+ res.data.productCreatedByThisMerchant)
          console.log('result');
          console.log(res);
          this.$store.commit('setSupplierProductSelectedForEdit', res.data);
          this.$store.commit('setSupplierProductIsEdit', true);
          this.$store.commit('setSupplierProductFormStatus', true);
          loader.hide();
          this.selectedSupplierProduct = res.data;
          //if suppProd is draft state the productProperties would be null, we should chnage it to null array
          if (res.data.productProperties == null) {
            this.selectedSupplierProduct.productProperties = [];
          }
          //this.selectedSupplierProduct.properties = [];
          let tempProductProperties = [];

          res.data.properties.forEach((element) => {
           // alert(element.id);
            element.propertyId = element.propertyId;
            element.mid = element.measurementUnitId;
            element.measurementUnitItem = element.units;
            tempProductProperties.push(element);
          });

          this.selectedSupplierProduct.properties = tempProductProperties;
          //Determine which kind Action can be done
          //confirmedSupplierProductsCount>1  and productCreatedByThisMerchant and productAdminConfirmed

          // "EditProdNoBase" or "EditProdByBase"
           
          if (
            !res.data.productAdminConfirmed &
            res.data.productCreatedByThisMerchant
          ) {
            this.editActionName = 'EditProdNoBase';
          }
          if (
            res.data.productAdminConfirmed &
            res.data.productCreatedByThisMerchant &
            (res.data.confirmedSupplierProductsCount == 1)
          ) {
            this.editActionName = 'EditProdNoBase';
          }
          if (
            res.data.productAdminConfirmed &
            !res.data.productCreatedByThisMerchant
          ) {
            this.editActionName = 'EditProdByBase';
          }
          //console.log("kazemi  this.editActionName is=>  "+  this.editActionName)
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
    getCategoryTypeItemsList() {
      const loader = this.$loading.show();
      enumsRepository()
        .getEnum('CategoryTypeItems', this.productBaseUrl)
        .then(({ data }) => {
          this.categoryTypeItemsList = data;
          this.getCategoryTypeLabel('Product');
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
    getCategoryTypeLabel(categoryType) {
      if (this.categoryTypeItemsList.length) {
        let result = null;
        result = this.categoryTypeItemsList.find(
          (el) => el.title == categoryType
        );
        this.categoryTypeDisplayName = result ? result.displayName : result;
      }
    },
    getConversaion() {
      const loader = this.$loading.show();

      let param = {
        objectId: this.id,
        topic: 'SupplierProduct',
        type: 'AdminMerchant',
        PageNumber: 1,
        ItemsPerPage: 999,
      };
      conversationRepository()
        .getConversation(this.contentBaseUrl, {}, param)
        .then((res) => {
          this.conversationList = res.data.list;
        })
        .catch((err) => {})
        .finally(() => loader.hide());
    },
  },
  watch: {
    editActionName(after, before) {
      //alert("ActionName after is =" + after + " before is :" + before)
    }
  }
};
</script>

<style></style>
